/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bold_Pink_Owl_SoarInputs */

const en_bold_pink_owl_soar = /** @type {(inputs: Bold_Pink_Owl_SoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rounds`)
};

const de_bold_pink_owl_soar = /** @type {(inputs: Bold_Pink_Owl_SoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Runden`)
};

/**
* | output |
* | --- |
* | "Rounds" |
*
* @param {Bold_Pink_Owl_SoarInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bold_pink_owl_soar = /** @type {((inputs?: Bold_Pink_Owl_SoarInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bold_Pink_Owl_SoarInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bold_pink_owl_soar(inputs)
	return de_bold_pink_owl_soar(inputs)
});